package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.ui.theme.LocalTheme.p100
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.views.AppTheme

@Composable
fun NoSearchResultLayout(modifier: Modifier = Modifier, label: String = stringResource(SR.strings.no_results_found)) {
    Column(modifier = modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally) {
        Spacer(modifier = Modifier.weight(0.2f))
        Image(
            modifier            = Modifier
                .width(p100)
                .aspectRatio(1f),
            painter             = painterResource(SRC.images.no_results_found_image),
            contentDescription  = null
        )
        Texts.LabelLarge(
            modifier    = Modifier.padding(top = p16),
            color       = AppTheme.current.colors.onSurfaceVariant,
            text        = label
        )
        Spacer(modifier = Modifier.weight(1f))
    }
}

/*@Preview
@Composable
fun NoSearchResultLayoutPreview(){
    AppTheme.setup(false)
    AppThemeView {
        NoSearchResultLayout()
    }
}*/